export interface AddItemValidationInput {
  itemName: string;
  manufacturerName: string;
  manufacturerPartNumber: string;
  quantityFound: string;
  /**
   * True when the user selected an item from the typeahead that already exists
   * in the cached item list. In that case the manufacturer fields are rendered
   * read-only, so requiring them would be impossible to satisfy when the cached
   * item lacks manufacturer data.
   */
  isExistingItem: boolean;
}

export interface AddItemValidationResult {
  valid: boolean;
  errorMessage?: string;
}

/**
 * Validates the Add Item form for the Tool Tracker mobile inventory-count flow.
 * Manufacturer fields are only required when the item is brand-new (typed by the
 * user, not selected from the typeahead) — matching the API contract in
 * AddOrUpdateInventoryCountDetail and the web "add to count" behavior.
 */
export function validateAddItemInputs(
  input: AddItemValidationInput
): AddItemValidationResult {
  if (!input.itemName) {
    return { valid: false, errorMessage: 'Item name is required' };
  }

  if (!input.isExistingItem) {
    if (!input.manufacturerName) {
      return { valid: false, errorMessage: 'Manufacturer name is required' };
    }
    if (!input.manufacturerPartNumber) {
      return {
        valid: false,
        errorMessage: 'Manufacturer part number is required',
      };
    }
  }

  const qty = Number(input.quantityFound);
  if (isNaN(qty) || qty === 0) {
    return { valid: false, errorMessage: 'Invalid quantity found.' };
  }

  return { valid: true };
}
